import { Box, Card, Grid, Skeleton, Stack } from "@mui/material";
import FlexBox from "../../layouts/flexbox";

export default function RecordingCardSkeleton() {
  return (
    <Card
      elevation={0}
      variant="outlined"
      sx={{
        p: 2,
        pb: 0,
        borderRadius: 2,
        borderColor: "divider",
        overflow: "hidden",
      }}
    >
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          lg={6}
          xl={4.5}
          sx={{
            borderRight: { xs: "none", md: 1 },
            borderColor: { md: "divider" },
            p: 2,
          }}
        >
          <FlexBox gap={2} flexDirection={{ xs: "column", sm: "row" }}>
            <Box
              sx={{
                position: "relative",
                width: { xs: "100%", sm: 320 },
                maxWidth: "100%",
                height: 250,
                flexShrink: 0,
                mx: { xs: "auto", sm: 0 },
              }}
            >
              <Skeleton
                variant="rectangular"
                animation="wave"
                height={250}
                sx={{
                  borderRadius: "16px",
                  bgcolor: "action.hover",
                }}
              />
              <Skeleton
                variant="rounded"
                animation="wave"
                height={30}
                width={132}
                sx={{
                  position: "absolute",
                  bottom: 16,
                  left: "50%",
                  transform: "translateX(-50%)",
                  borderRadius: "10px",
                  bgcolor: "action.selected",
                }}
              />
            </Box>
            <Stack spacing={1.5} flex={1} sx={{ minWidth: 0, pt: { xs: 0, sm: 0.5 } }}>
              <FlexBox gap={1.5} alignItems="center">
                <Skeleton variant="circular" animation="wave" width={24} height={24} />
                <Skeleton variant="text" animation="wave" width="85%" height={22} />
              </FlexBox>
              <FlexBox gap={1.5} alignItems="center">
                <Skeleton variant="circular" animation="wave" width={24} height={24} />
                <Skeleton variant="text" animation="wave" width="65%" height={22} />
              </FlexBox>
              <FlexBox gap={1.5} alignItems="center">
                <Skeleton variant="circular" animation="wave" width={24} height={24} />
                <Skeleton variant="text" animation="wave" width="55%" height={22} />
              </FlexBox>
              <FlexBox gap={1.5} alignItems="center">
                <Skeleton variant="circular" animation="wave" width={24} height={24} />
                <Skeleton variant="text" animation="wave" width="70%" height={22} />
              </FlexBox>
              <FlexBox gap={1} flexWrap="wrap" mt={1}>
                <Skeleton
                  variant="rounded"
                  animation="wave"
                  width={108}
                  height={36}
                  sx={{ borderRadius: 1 }}
                />
                <Skeleton
                  variant="rounded"
                  animation="wave"
                  width={108}
                  height={36}
                  sx={{ borderRadius: 1 }}
                />
              </FlexBox>
            </Stack>
          </FlexBox>
        </Grid>
        <Grid item xs={12} lg={6} xl={7.5} sx={{ p: { md: 2 } }}>
          <Stack spacing={2}>
            <Skeleton
              variant="rounded"
              animation="wave"
              height={40}
              sx={{ borderRadius: "10px", maxWidth: 420, bgcolor: "action.hover" }}
            />
            <Stack spacing={1.25} sx={{ pl: 0.5 }}>
              <Skeleton variant="text" animation="wave" width="92%" height={18} />
              <Skeleton variant="text" animation="wave" width="88%" height={18} />
              <Skeleton variant="text" animation="wave" width="76%" height={18} />
              <Skeleton variant="text" animation="wave" width="84%" height={18} />
              <Skeleton variant="text" animation="wave" width="40%" height={18} />
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
}
